import { useEffect } from 'react';

import { tracking } from '@iwoca/frontend-tracking-library';
import { Trans } from '@lingui/react/macro';

import { useOffersDE } from '../../../../hooks/useOffers/useOffersDE';
import { useGetStateQuery } from '../../../../lendingApi/lendingApiQueries';
import { getAmplitudeDefaultEventProperties } from '../../../../utils/amplitudeEvents';
import logger from '../../../../utils/logger';
import { Button } from '../../../Button/Button';
import { documentTypes } from '../../tradingHistory.helpers';
import styles from '../SubmitDocuments.module.css';

type TProps = {
  isSubmitted: boolean;
  setIsSubmitted: (isSubmitted: boolean) => void;
};
const SubmitDocumentsButtonDE = ({ isSubmitted, setIsSubmitted }: TProps) => {
  const {
    documentRequirements,
    handleDecision,
    isDeciding,
    isRefetchingOffers,
    isSyncingState,
  } = useOffersDE();

  const { isStateFetching } = useGetStateQuery();

  useEffect(() => {
    if (!documentRequirements || !isSubmitted) {
      return;
    }

    const requiredDocumentType = documentRequirements.find(
      (requirement) =>
        requirement.is_optional === false &&
        (requirement.status === 'error' || requirement.status === 'required'),
    );

    const elementToScrollTo = document.getElementById(
      `document-requirement-${getDocumentRequirementId(
        requiredDocumentType?.type,
      )}`,
    );

    if (elementToScrollTo) {
      elementToScrollTo.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, [documentRequirements, isSubmitted]);

  const handleClick = async () => {
    tracking.ampli.tradingHistorySubmitted({
      'Page version': 'v2',
      ...getAmplitudeDefaultEventProperties(),
    });

    await handleDecision();
    setIsSubmitted(true);
  };

  const getDocumentRequirementId = (requirement?: string) => {
    if (!requirement) {
      return null;
    }

    const translatedRequirement = documentTypes[requirement];

    if (!translatedRequirement) {
      logger.error('unmatched DE data requirement');

      return 'bank statement';
    }

    return translatedRequirement.split('_').join(' ');
  };

  return (
    <Button
      className={styles.button}
      loading={isDeciding || isRefetchingOffers}
      onClick={handleClick}
      disabled={isSyncingState || isStateFetching}
    >
      <Trans>Send your application</Trans>
    </Button>
  );
};

export default SubmitDocumentsButtonDE;
